import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, Skeleton, Stack, Typography } from '@mui/material';
import { TuneOutlined } from '@mui/icons-material';
import { useEmailSettings } from '../../components/email/useEmailSettings';
import EmailActivity from '../../components/email/EmailActivity';

/** Email → Sent emails: everything that went to families, with failures one click from Resend. */
const SentEmailsPage: React.FC = () => {
  const { settings, error } = useEmailSettings();

  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={2} sx={{ mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight={700}>Sent emails</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Every email sent to families, newest first. If one fails, send it again from here.
          </Typography>
        </Box>
        <Button component={RouterLink} to="/app/email/setup" variant="outlined" startIcon={<TuneOutlined />} sx={{ textTransform: 'none', flexShrink: 0 }}>
          Email setup
        </Button>
      </Stack>
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : settings ? (
        <EmailActivity types={settings.types} />
      ) : (
        <Skeleton variant="rounded" height={360} sx={{ borderRadius: 2 }} />
      )}
    </Box>
  );
};

export default SentEmailsPage;
